import { toMP3 } from 'pages/Remixer/audioHelpers';

export const isAudioFile = (file: File) => file.type.startsWith('audio/');

export const replaceFileExtension = (fileName: string, extension: string) =>
  fileName.replace(/\.([^.]+)$/, `.${extension}`);

export const createAudioFileFromAudioBuffer = async (
  audioBuffer: AudioBuffer,
  name: string
) => {
  const mp3Buffer = toMP3(audioBuffer);
  return new File(mp3Buffer, name, { type: 'audio/mpeg' });
};
